import { useActions } from '@tock/shared/utils/connect';
import { useEffect } from 'react';

/**
 * calls redux actions for the navigation bar,
 * all search landing pages have a back button and city picker
 */
export function useSetSearchNavigation(): void {
  const { actions } = useActions();
  useEffect(() => {
    actions.navigation.set({
      hasBack: true,
      hasCityPicker: true,
    });
    // only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
